import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    risks: { type: Array as PropType<string[]>, required: true },
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  methods: {
    changeConsent(event: Event): void {
      this.$emit("update:modelValue", (<HTMLInputElement>event.target).checked);
    },
  },
});
